<template>
  <div class="col-12">
    <div class="card-body px-3">
      <b-tabs pills content-class="mt-3" small v-model="current_tab">
        <b-tab :title="$t('message.contracts.offers_tab')" lazy id="offers-tab">
          <div class="row">
            <div class="col-12">
              <div
                class="togglebutton other mt-md-3 form-label-group single-option-toggle-small"
              >
                <label class="control-label">
                  <!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
                  <input type="checkbox" v-model="show_declined" />
                  <span class="toggle"></span>
                  <span class="choise_2 text-nowrap">{{
                    $t("message.contracts.offers_show_declined")
                  }}</span>
                </label>
              </div>
            </div>
          </div>
          <b-tabs
            pills
            content-class="mt-3"
            small
            v-model="current_offers_tab"
            v-if="offer_groups.length > 0"
          >
            <b-tab
              v-for="(group, index) in offer_groups"
              :title="group_labels[index]"
              lazy
              :key="'tb' + index"
            >
              <b-table
                responsive
                :tbody-tr-class="rowClass"
                :fields="offer_fields"
                :items="group.offers"
                @row-clicked="showModalOffer"
              >
                <template v-slot:cell(contract_date)="data">
                  {{ momentum(data.value) }}
                </template>
                <template v-slot:cell(buttons)="data">
                  <div class="text-right">
                    <button
                      class="btn btn-link"
                      @click="showModalOffer(index, data.item, data.index)"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                    <!--<button v-if="data.item.status !== 1" class="btn btn-sm btn-danger btn-round" @click="removeOffer(data.index)"><i class="fa fa-trash"></i></button> -->
                  </div>
                </template>
              </b-table>
            </b-tab>
          </b-tabs>

          <!-- <b-button v-if="!is_owner && !offer_is_accepted && can_add_offer" variant="success" @click="add_offer()" v-if="!is_owner && !is_deal">-->
          <!--  {{$t('message.contracts.offer_new')}}
                        </b-button> -->
          <!--<b-modal id="modal-offer-new" size="lg" :title="$t('message.contracts.offer_new')" :hide-footer=true button-size="lg">
                        <offer-new></offer-new>
                    </b-modal> -->
          <b-modal
            id="modal-offer"
            size="lg"
            :title="$t('message.contracts.single_offer')"
            button-size="lg"
          >
            <offer-single :offer="opened_offer"> </offer-single>
            <template v-slot:modal-footer="{}">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <!--<b-button class="mr-auto"  v-if="!opened_offer.no_changes && opened_offer.status !== 1" variant="outline-danger" @click="answer(opened_offer)">
                            {{$t('message.contracts.offer_answer')}}
                        </b-button> -->
              <b-button
                class="mr-auto"
                v-if="!opened_offer.no_changes && opened_offer.can_show_chain"
                variant="outline-danger"
                @click="showChain(opened_offer)"
              >
                <span>{{
                  $t("message.contracts.offer_show_chain_answer")
                }}</span>
              </b-button>
              <!--<b-button v-if="opened_offer.status !== 1" variant="success" class="mr-5" @click="accept(opened_offer)">
                            {{$t('message.contracts.offer_accept')}}
                        </b-button> -->
              <!-- Button with custom close trigger value -->
              <!-- <b-button v-if="opened_offer.status !== 1" variant="danger" @click="decline(opened_offer)">
                            {{$t('message.contracts.offer_decline')}}
                        </b-button> -->
            </template>
          </b-modal>
          <b-modal
            id="modal-chain"
            hide-footer
            size="lg"
            :title="$t('message.contracts.offer_chain_title')"
          >
            <div v-if="!show_current_chain">
              <div class="table table-responsive">
                <table
                  class="table email-table no-wrap table-hover v-middle mb-0 font-14"
                >
                  <tbody>
                    <tr
                      v-for="(item, i) in opened_offer.chain"
                      :key="i"
                      @click="show_more_in_chain(i)"
                    >
                      <td>
                        {{ item.attis_contract_offer_change_user.org_name }}
                      </td>
                      <td :title="item.attis_contract_offer_change_date">
                        {{ item.attis_contract_offer_change_date }}
                      </td>
                      <td>
                        <div
                          v-if="item.attis_contract_offer_answer.length > 20"
                        >
                          <span>{{
                            item.attis_contract_offer_answer.substring(0, 20)
                          }}</span>
                          <span v-if="uncollapse != i">...</span>
                          <span v-else>{{
                            item.attis_contract_offer_answer.substring(
                              20,
                              item.attis_contract_offer_answer.length,
                            )
                          }}</span>
                        </div>
                        <div v-else>
                          <span>{{ item.attis_contract_offer_answer }}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="show_current_chain">
              <button
                class="btn btn-secondary"
                @click.prevent.stop="show_current_chain = false"
              >
                {{ $t("message.back") }}
              </button>
              <div class="email-content">
                <div class="email-head">
                  <div
                    class="email-head-sender d-flex align-items-center justify-content-between flex-wrap"
                  >
                    <div class="d-flex align-items-center">
                      <div class="sender d-flex align-items-center">
                        <span>{{
                          current_offer_chain
                            .attis_contract_offer_change_dateattis_contract_offer_change_user
                            .org_name
                        }}</span>
                      </div>
                    </div>
                    <div class="date">
                      {{ current_offer_chain.attis_contract_offer_change_date }}
                    </div>
                  </div>
                </div>
                <div class="email-body">
                  {{ $t("message.contracts.delivery_price") }}:
                  <strong>{{ current_offer_chain.shipping_cost }}</strong>
                  <hr />
                  {{ current_offer_chain.attis_contract_offer_change_text }}
                </div>
              </div>
            </div>
          </b-modal>
        </b-tab>

        <b-tab
          v-if="is_courier"
          :title="$t('message.contracts.couriers_tab')"
          lazy
          id="couriers-tab"
        >
          <contracts-couriers-search
            :is_deal="true"
            :can_add="false"
            :is_owner="false"
            :roles="user_role"
            :is_full="true"
          >
          </contracts-couriers-search>
        </b-tab>
        <b-tab
          v-if="is_broker"
          :title="$t('message.contracts.brokers_tab')"
          lazy
          id="brokers-tab"
        >
          <contracts-brokers-search
            :is_deal="true"
            :can_add="false"
            :is_owner="false"
            :roles="user_role"
            :is_full="true"
          >
          </contracts-brokers-search>
        </b-tab>

        <b-tab
          :title="$t('message.account.insurance_requests')"
          lazy
          id="insurance-tab"
        >
          <b-modal
            id="modal-insurance_requests_full"
            centered
            :hide-footer="true"
            :title="$t('message.account.insurance_requests')"
          >
            <div v-if="show_insurance_request">
              <div class="row">
                <div class="col-6 text-muted">
                  {{ $t("message.account.org_name") }}
                </div>
                <div class="col-6">
                  {{ current_insurance_request.org_name }}
                </div>
                <div class="col-6 text-muted">
                  {{ $t("message.account.ceo_name") }}
                </div>
                <div class="col-6">
                  {{ current_insurance_request.ceo_name }}
                </div>

                <div class="col-6 text-muted">
                  {{ $t("message.account.statute") }}
                </div>
                <div class="col-6">
                  <a
                    :href="current_insurance_request.statute"
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ $t("message.account.statute") }}
                    <i class="fas fa-external-link-alt"></i
                  ></a>
                </div>
                <div class="col-6 text-muted">
                  {{ $t("message.account.registration_certificate") }}
                </div>
                <div class="col-6">
                  <a
                    :href="current_insurance_request.registration_certificate"
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ $t("message.account.registration_certificate") }}
                    <i class="fas fa-external-link-alt"></i
                  ></a>
                </div>
                <div class="col-6 text-muted">
                  {{ $t("message.account.signature_right_certificate") }}
                </div>
                <div class="col-6">
                  <a
                    :href="
                      current_insurance_request.signature_right_certificate
                    "
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ $t("message.account.signature_right_certificate") }}
                    <i class="fas fa-external-link-alt"></i
                  ></a>
                </div>
                <div class="col-6 text-muted">
                  {{ $t("message.account.ceo_passport") }}
                </div>
                <div class="col-6">
                  <a
                    :href="current_insurance_request.ceo_passport"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ $t("message.account.ceo_passport") }}
                    <i class="fas fa-external-link-alt"></i
                  ></a>
                </div>
              </div>

              <!-- load document -->
              <form-insurance
                :readonly="true"
                v-if="current_insurance_request.insurance_type == 6"
                :document_id="current_insurance_request.document_id"
              ></form-insurance>
              <form-liability-insurance
                :readonly="true"
                v-else
                :document_id="current_insurance_request.document_id"
              ></form-liability-insurance>
              <!-- end load document -->
            </div>
          </b-modal>

          <b-tabs
            pills
            content-class="mt-3"
            small
            v-model="current_insurance_tab"
          >
            <b-tab
              :title="$t('message.account.offer_group_mine')"
              lazy
              id="my-insurance-tab"
            >
              <div>
                <b-table
                  responsive=""
                  :fields="insurance_requests_fields"
                  :items="my_insurance_requests"
                >
                  <template v-slot:cell(action)="data">
                    <button
                      class="btn btn-link"
                      @click="showInsuranceRequest(data.item)"
                      :title="$t('message.contracts.show_ktzh_request')"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </template>
                  <template v-slot:cell(status)="data">
                    {{
                      $t(
                        "message.account.insurance_request_status_" +
                          data.value,
                      )
                    }}
                  </template>
                  <template v-slot:cell(date_time)="data">
                    {{ data.value }}
                  </template>
                  <template v-slot:cell(amount)="data">
                    {{ data.value.toLocaleString() }}
                  </template>
                  <template v-slot:cell(insurance_type)="data">
                    {{ $t("message.account.insurance_type_" + data.value) }}
                  </template>
                </b-table>
              </div>
            </b-tab>

            <b-tab
              v-if="is_insurer"
              :title="$t('message.account.offer_group_for_me')"
              lazy
              id="insurers-tab"
            >
              <div>
                <b-table
                  responsive=""
                  :fields="insurerfields"
                  :items="insurer_requests"
                >
                  <template v-slot:cell(action)="data">
                    <button
                      class="btn btn-link"
                      @click="showInsuranceRequest(data.item)"
                      :title="$t('message.contracts.show_ktzh_request')"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                  </template>
                  <template v-slot:cell(status)="data">
                    {{
                      $t(
                        "message.account.insurance_request_status_" +
                          data.value,
                      )
                    }}
                  </template>
                  <template v-slot:cell(date_time)="data">
                    {{ data.value }}
                  </template>
                  <template v-slot:cell(amount)="data">
                    {{ data.value.toLocaleString() }}
                  </template>
                  <template v-slot:cell(insurance_type)="data">
                    {{ $t("message.account.insurance_type_" + data.value) }}
                  </template>
                </b-table>
              </div>
            </b-tab>

            <!-- <b-tab v-for="(group, index) in insurance_groups" :title="group_labels[index]" lazy>

                            <div v-if="!show_insurance_request">
                                <b-table :fields="insurance_requests_fields" :items="group.insurance_requests">
                                    <template v-slot:cell(action)="data">
                                        <button class="btn btn-link p-0" @click="showInsuranceRequest(data.item)" :title="$t('message.contracts.show_ktzh_request')"><i class="fa fa-eye"></i></button>
                                    </template>
                                    <template v-slot:cell(status)="data">
                                        {{$t('message.account.insurance_request_status_'+data.value)}}
                                    </template>
                                    <template v-slot:cell(date_time)="data">
                                        {{data.value}}
                                    </template>
                                    <template v-slot:cell(amount)="data">
                                        {{(data.value).toLocaleString()}}
                                    </template>
                                    <template v-slot:cell(insurance_type)="data">
                                        {{$t('message.account.insurance_type_'+data.value)}}
                                    </template>
                                    
                                </b-table>
			                </div>

                        </b-tab> -->
          </b-tabs>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      current_tab: 0,
      current_offers_tab: 0,
      current_insurance_tab: 0,
      show_declined: false,
      opened_offer: {},
      uncollapse: -1,
      show_current_chain: false,
      current_offer_chain: {},
      offer_groups: [],
      insurance_groups: [],
      my_insurance_requests: [],
      insurer_requests: [],
      group_labels: [
        this.$t("message.account.offer_group_mine"),
        this.$t("message.account.offer_group_for_me"),
      ],
      show_insurance_request: false,

      current_insurance_request: {
        contract_id: { value: "" },
        org_name: "",
        ceo_name: "",
        statute: null,
        registration_certificate: null,
        signature_right_certificate: null,
        ceo_passport: null,
      },

      offer_fields: [
        {
          key: "buttons",
          label: "",
        },
        {
          key: "ID",
          label: "",
        },
        {
          key: "name",
          label: this.$t("message.contracts.offer_from"),
        },
        {
          key: "target_name",
          label: this.$t("message.contracts.offer_target_name"),
        },
        {
          key: "offer",
          label: this.$t("message.contracts.offer"),
        },
        {
          key: "discount_percents",
          label: this.$t(
            "message.contracts.invoice_products_DiscountPercentage",
          ),
        },
        {
          key: "discount_amount",
          label: this.$t("message.contracts.invoice_products_Discount"),
        },
        {
          key: "contract_date",
          label: this.$t("message.contracts.contract_date"),
        },
      ],
      insurance_requests_fields: [
        { key: "id", label: "ID" },
        { key: "org_name", label: this.$t("message.account.org_name") },
        { key: "ceo_name", label: this.$t("message.account.ceo_name") },
        { key: "status", label: this.$t("message.account.status") },
        { key: "amount", label: this.$t("message.account.amount") },
        { key: "date_time", label: this.$t("message.account.date_time") },
        {
          key: "insurance_type",
          label: this.$t("message.account.insurance_type"),
        },
        { key: "action", label: " " },
      ],
      insurer_fields: [
        { key: "id", label: "ID" },
        { key: "org_name", label: this.$t("message.account.org_name") },
        { key: "ceo_name", label: this.$t("message.account.ceo_name") },
        { key: "status", label: this.$t("message.account.status") },
        { key: "amount", label: this.$t("message.account.amount") },
        { key: "date_time", label: this.$t("message.account.date_time") },
        {
          key: "insurance_type",
          label: this.$t("message.account.insurance_type"),
        },
        { key: "action", label: " " },
      ],
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    user_role() {
      if (typeof this.$store.state.user !== "undefined")
        return this.$store.state.user.Roles;
      else return ["Owner"];
    },
    is_insurer() {
      // return true
      let has_role = false;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "insurer") has_role = true;
      });
      return has_role;
    },
    is_broker() {
      let has_role = false;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "broker") has_role = true;
      });
      return has_role;
    },
    is_courier() {
      let has_role = false;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "carrier") has_role = true;
      });
      return has_role;
    },
  },
  methods: {
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    load() {
      axios.get(window.base + "/contract/getFullOffers").then((response) => {
        this.offer_groups = response.data.contract_offer_groups;

        axios
          .get(window.base + "/account/load_all_insurance_requests")
          .then((response) => {
            this.insurer_requests = response.data;

            axios
              .get(window.base + "/account/load_my_insurance_requests")
              .then((response) => {
                this.my_insurance_requests = response.data;
              });
          });
      });
    },
    filtered_offers_list() {
      return this.offers_list.filter((i) => {
        if (this.show_declined == true) {
          if (i.status === -1) return i;
        } else {
          if (i.status !== -1) return i;
        }
      });
    },

    showModalOffer(groupIndex, item, index, event) {
      console.log(item);
      this.opened_offer = item;
      this.$set(
        this.offer_groups[groupIndex].offers[index],
        "can_show_chain",
        false,
      );
      this.$bvModal.show("modal-offer");
      axios
        .get(window.base + "/contract/chainOffer?offer_id=" + item.ID)
        .then((response) => {
          if (response.data.length > 0)
            this.$set(
              this.offer_groups[groupIndex].offers[index],
              "can_show_chain",
              true,
            );
        });
    },

    removeOffer(index) {
      axios
        .get(
          window.base +
            "/contract/deleteOffer?offer_id=" +
            this.offers_list[index].ID,
        )
        .then((response) => {
          this.offers_list.splice(index, 1);
          if (response.data == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$t("message.message.offer-deleted"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$t("message.message.offer-not-deleted") +
                " (" +
                response.data +
                ")",
              timeout: 5000,
            }).show();
          }
        });
    },

    showChain(offer) {
      this.opened_offer = offer;
      axios
        .get(window.base + "/contract/chainOffer?offer_id=" + offer.ID)
        .then((response) => {
          console.log("chain response");
          console.log(response.data);
          this.$set(this.opened_offer, "chain", response.data);
          this.$bvModal.show("modal-chain");
        });
    },
    show_more_in_chain(index) {
      // console.log(1)
      if (this.uncollapse == index) this.uncollapse = -1;
      else this.uncollapse = index;
      // this.$set(this.opened_offer.chain[index], 'uncollapse', !this.opened_offer.chain[index].uncollapse)
    },
    showOfferChain(item) {
      this.current_offer_chain = { ...item };
    },
    rowClass(item) {
      return item.status == 1 ? "bg-success-light" : "";
    },
    showInsuranceRequest(inurance_request) {
      this.current_insurance_request = inurance_request;
      this.show_insurance_request = true;
      this.$bvModal.show("modal-insurance_requests_full");
    },
  },
};
</script>
